import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _throttle from 'lodash/throttle'

// Import Components
import Box from '@material-ui/core/Box'
import KeplerGl from './KeplerGl'
import Dashboard from '../Dashboard/Dashboard'

// Import Global Variables and Configs
import { MAP_CONFIG } from '../../App.config'

// Import Actions & Methods
import { loadInitialCustomMap } from '../../store/actions/mapActions'
import { setLayerSizeWithZoomLevel } from '../../store/actions/layerActions'
import { loadDnccPolygon, removeDummySiteData } from '../../store/actions/dataActions'

class KeplerGlMap extends React.PureComponent {
    state = {
        mapWidth: window.innerWidth,
        mapHeight: window.innerHeight
    }

    componentDidMount() {
        // Add Window Resize Event
        this.onResize = _throttle(this.updateAppSize, 0, { trailing: true })
        window.addEventListener('resize', this.onResize)

        // Load Initial Custom Map Without Data
        this.props.dispatch( loadInitialCustomMap() )

        // Load DNCC Polygon
        this.props.dispatch( loadDnccPolygon() )
    }

    componentDidUpdate(prevProps) {
        const { zoom, clicked } = this.props

        // Set Point Layer Radius with Zoom Level Change
        if(prevProps.zoom !== zoom) {
            this.props.dispatch( setLayerSizeWithZoomLevel(zoom) )
        }

        // If Clicked Changed from valid to null in props, remove Dummy Site Data
        if(prevProps.clicked && !clicked) {
            this.props.dispatch( removeDummySiteData() )
        }
    }

    updateAppSize = () => {
        this.setState({
            mapWidth: window.innerWidth,
            mapHeight: window.innerHeight
        })
    }

    render() {
        const { mapWidth, mapHeight } = this.state

        return (
            <Box { ...mapContainerStyles }>
                <KeplerGl
                    id='map'
                    mapboxApiAccessToken={ MAP_CONFIG.MAPBOX_TOKEN }
                    width={ mapWidth }
                    height={ mapHeight }
                />

                <Dashboard />
            </Box>
        )
    }
}

// JSS Styles
const mapContainerStyles = {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
}

// Prop Types
KeplerGlMap.propTypes = {
    zoom: PropTypes.number,
    clicked: PropTypes.object
}

KeplerGlMap.defaultProps = {
    zoom: 11,
    clicked: null
}

const mapStateToProps = state => ({
    zoom: state.keplerGl.map ? state.keplerGl.map.mapState.zoom : 0,
    clicked: state.keplerGl.map ? state.keplerGl.map.visState.clicked : null
})
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(KeplerGlMap)